module.exports = __webpack_public_path__ + "static/smoke_shaft_height-672022c298228405a17415aba6def5c1.png";